var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification-new",
    transform: "translate(-4.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M28.352,17.623V14.948H26.278v3.1a1.033,1.033,0,0,0,.3.731l2.807,2.8v1.641H6.574V21.583l2.807-2.8a1.033,1.033,0,0,0,.3-.731V13.914A8.281,8.281,0,0,1,22.13,6.757V4.445a10.283,10.283,0,0,0-3.111-.823V1.5H16.944V3.621A10.369,10.369,0,0,0,7.611,13.914v3.71L4.8,20.424a1.033,1.033,0,0,0-.3.731v3.1a1.036,1.036,0,0,0,1.037,1.034H12.8v1.034a5.185,5.185,0,0,0,10.37,0V25.293h7.259a1.036,1.036,0,0,0,1.037-1.034v-3.1a1.033,1.033,0,0,0-.3-.731Zm-7.259,8.7a3.111,3.111,0,0,1-6.222,0V25.293h6.222Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 4.148,
    cy: 4.138,
    rx: 4.148,
    ry: 4.138,
    transform: "translate(24.204 4.603)",
    fill: "red"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.751e7ce444ba5a9aba52af4414034ac8.svg";
export { ForwardRef as ReactComponent };